import axios from "axios";
import store from "@/store";

const baseURL = `https://h59rfx3wm9.execute-api.us-east-1.amazonaws.com/prod/v1`; // Production.
// const baseURL = `https://jayon7xbeb.execute-api.us-east-1.amazonaws.com/test/v1`; // Test.
// const baseURL = `https://localhost:5001/v1`; // Dev.

let liberatorClient = axios.create({
  baseURL: baseURL,
  crossdomain: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

liberatorClient.interceptors.request.use(
  config => {
    // Clear any error that may be there.
    store.commit("CLEAR_LIBERATOR_ERROR");

    // Clear any success that may be there.
    store.commit("CLEAR_LIBERATOR_SUCCESS");

    // Set the sessionKey to the authenticated session.
    config.headers.sessionKey = GetSessionKey();
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// https://axios-http.com/docs/interceptors
liberatorClient.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  // If status is unauthorized, force the login prompt to show again
  if (error.response.status === 401) {    
    alert('Session has expired, please log in again.');
    store.commit("SET_SESSION", '');
    store.commit("SET_IS_LOGIN_REQUIRED", true);
  }
  return Promise.reject(error);
});

function GetSessionKey() {
  // If the session hasn't been set, return nothing.
  if (sessionStorage.session == undefined || sessionStorage.session == "") {
    return "";
  }

  // Translate the json into an object and get the sessionKey.
  var session = JSON.parse(sessionStorage.session);
  return session.sessionKey;
}

export default {
  GetSession() {
    if (sessionStorage.session == undefined || sessionStorage.session == "")
      return "";
    var session = JSON.parse(sessionStorage.session);
    return session;
  },

  getProperties(searchTerm, stages, useDates, startDate, endDate) {
    // var stagesCommaDelimited = stages.join();
    var headers = {
      headers: {
        searchTerm: searchTerm,
        stages: stages,
        useDates: useDates,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString()
      }
    };
    return liberatorClient.get("/properties", headers);
  },

  async getProperty(propertyId) {
    return await liberatorClient.get("/properties/" + propertyId);
  },

  async newMultifamilyProperty(property) {
    var url = `/properties/multifamily`;
    return await liberatorClient.post(url, property);
  },

  async updateMultifamilyPropertyAttributes(property) {
    var url = `/properties/multifamily/attributes`;
    return await liberatorClient.put(url, property);
  },

  async newPropertyByAddress(address, city, state, zip, latitude, longitude) {
    address = encodeURIComponent(address);
    city = encodeURIComponent(city);
    var options = {
      headers: {
        latitude: latitude,
        longitude: longitude
      }
    };
    var url = `/properties/${address}/${city}/${state}/${zip}`;
    return await liberatorClient.post(url, {}, options);
  },

  async newPropertyByMlsNumber(mlsMarket, mlsNumber) {
    return await liberatorClient.post(`/properties/${mlsMarket}/${mlsNumber}`);
  },

  newPropertyNote(propertyId, stage, note) {
    var headers = {
      headers: {
        stage: stage,
        note: note
      }
    };
    var url = `/properties/${propertyId}/notes`;
    return liberatorClient.post(url, {}, headers);
  },

  updatePropertyStage(propertyId, stage) {
    var url = `/properties/${propertyId}/activities/${stage}`;
    return liberatorClient.put(url);
  },

  updatePropertyNote(propertyId, note) {
    var headers = {
      headers: {
        stage: note.stage,
        note: note.theNote,
        createdUtc: note.createdUtc
      }
    };
    var url = `/properties/${propertyId}/notes/${note.id}`;
    return liberatorClient.put(url, {}, headers);
  },

  deletePropertyNote(propertyId, noteId) {
    var url = `/properties/${propertyId}/notes/${noteId}`;
    return liberatorClient.delete(url);
  },

  newPropertyEvaluation(propertyId) {
    var url = `/properties/${propertyId}/evaluations`;
    return liberatorClient.post(url);
  },

  deletePropertyEvaluation(propertyId, evaluationId) {
    var url = `/properties/${propertyId}/evaluations/${evaluationId}`;
    return liberatorClient.delete(url);
  },

  updatePropertyEvaluationSaleComps(
    propertyId,
    evaluationId,
    searchType,
    searchTerm,
    sqftPlusMinus,
    bedsMin,
    bedsMax,
    bathsMin,
    bathsMax,
    garageMin,
    garageMax,
    yearBuiltPlusMinus,
    monthsClosed,
    confineToCounty,
    confineToZip,
    ignoreParametersExceptMonthsClosed
  ) {
    var headers = {
      headers: {
        searchType: searchType,
        searchTerm: searchTerm,
        sqftPlusMinus: sqftPlusMinus,
        bedsMin: bedsMin,
        bedsMax: bedsMax,
        bathsMin: bathsMin,
        bathsMax: bathsMax,
        garageMin: garageMin,
        garageMax: garageMax,
        yearBuiltPlusMinus: yearBuiltPlusMinus,
        monthsClosed: monthsClosed,
        confineToCounty: confineToCounty,
        confineToZip: confineToZip,
        ignoreParametersExceptMonthsClosed: ignoreParametersExceptMonthsClosed
      }
    };
    var url = `/properties/${propertyId}/evaluations/${evaluationId}/salecomps`;
    return liberatorClient.put(url, {}, headers);
  },

  updatePropertyEvaluationRentComps(
    propertyId,
    evaluationId,
    searchType,
    searchTerm,
    sqftPlusMinus,
    bedsMin,
    bedsMax,
    bathsMin,
    bathsMax,
    garageMin,
    garageMax,
    yearBuiltPlusMinus,
    monthsClosed,
    confineToCounty,
    confineToZip,
    ignoreParametersExceptMonthsClosed
  ) {
    var headers = {
      headers: {
        searchType: searchType,
        searchTerm: searchTerm,
        sqftPlusMinus: sqftPlusMinus,
        bedsMin: bedsMin,
        bedsMax: bedsMax,
        bathsMin: bathsMin,
        bathsMax: bathsMax,
        garageMin: garageMin,
        garageMax: garageMax,
        yearBuiltPlusMinus: yearBuiltPlusMinus,
        monthsClosed: monthsClosed,
        confineToCounty: confineToCounty,
        confineToZip: confineToZip,
        ignoreParametersExceptMonthsClosed: ignoreParametersExceptMonthsClosed
      }
    };
    var url = `/properties/${propertyId}/evaluations/${evaluationId}/rentcomps`;
    return liberatorClient.put(url, {}, headers);
  },

  includeExcludePropertyEvaluationSaleComp(
    propertyId,
    evaluationId,
    saleCompId,
    include
  ) {
    var headers = {
      headers: {
        include: include
      }
    };
    var url = `/properties/${propertyId}/evaluations/${evaluationId}/salecomps/${saleCompId}`;
    return liberatorClient.put(url, {}, headers);
  },

  includeExcludePropertyEvaluationRentComp(
    propertyId,
    evaluationId,
    rentCompId,
    include
  ) {
    var headers = {
      headers: {
        include: include
      }
    };
    var url = `/properties/${propertyId}/evaluations/${evaluationId}/rentcomps/${rentCompId}`;
    return liberatorClient.put(url, {}, headers);
  },

  updatePropertyEvaluationCalculator(
    propertyId,
    evaluationId,
    dealEstimatedMarketValue,
    dealEstimatedAppraisedValue,
    dealPurchasePrice,
    dealSellerContribution,
    dealSurvey,
    dealAppraisal,
    dealInspection,
    dealRepairsMakeReady,
    dealHoaAnnual,
    dealPropertyTaxAnnual,
    dealPropertyInsuranceAnnual,
    dealMiscellaneousMonthly,
    dealRent,
    dealMaxRefiCashback,
    convDownpaymentPercent,
    convLoanTermInYears,
    convInterestRatePercent,
    convLenderAndTitleFees,
    convMonthsTaxAndInsurance,
    convMortgageInsuranceAnnual,
    convShow,
    hardMoneyLoanToValuePercent,
    hardMoneyLenderAndTitleFees,
    hardMoneyInterestRatePercent,
    hardMoneyMonthsToRefinance,
    hardMoneyRollInLenderFees,
    hardMoneyWeeksUntilLeased,
    refinanceLoanToValuePercent,
    refinanceLoanTermInYears,
    refinanceInterestRatePercent,
    refinanceLenderAndTitleFees,
    refinanceMonthsTaxAndInsurance,
    refinanceMortgageInsuranceAnnual,
    hardShow
  ) {
    var options = {
      headers: {
        dealEstimatedMarketValue: dealEstimatedMarketValue,
        dealEstimatedAppraisedValue: dealEstimatedAppraisedValue,
        dealPurchasePrice: dealPurchasePrice,
        dealSellerContribution: dealSellerContribution,
        dealSurvey: dealSurvey,
        dealAppraisal: dealAppraisal,
        dealInspection: dealInspection,
        dealRepairsMakeReady: dealRepairsMakeReady,
        dealHoaAnnual: dealHoaAnnual,
        dealPropertyTaxAnnual: dealPropertyTaxAnnual,
        dealPropertyInsuranceAnnual: dealPropertyInsuranceAnnual,
        dealMiscellaneousMonthly: dealMiscellaneousMonthly,
        dealRent: dealRent,
        dealMaxRefiCashback: dealMaxRefiCashback,
        convDownpaymentPercent: convDownpaymentPercent,
        convLoanTermInYears: convLoanTermInYears,
        convInterestRatePercent: convInterestRatePercent,
        convLenderAndTitleFees: convLenderAndTitleFees,
        convMonthsTaxAndInsurance: convMonthsTaxAndInsurance,
        convMortgageInsuranceAnnual: convMortgageInsuranceAnnual,
        convShow: convShow,
        hardMoneyLoanToValuePercent: hardMoneyLoanToValuePercent,
        hardMoneyLenderAndTitleFees: hardMoneyLenderAndTitleFees,
        hardMoneyInterestRatePercent: hardMoneyInterestRatePercent,
        hardMoneyMonthsToRefinance: hardMoneyMonthsToRefinance,
        hardMoneyRollInLenderFees: hardMoneyRollInLenderFees,
        hardMoneyWeeksUntilLeased: hardMoneyWeeksUntilLeased,
        refinanceLoanToValuePercent: refinanceLoanToValuePercent,
        refinanceLoanTermInYears: refinanceLoanTermInYears,
        refinanceInterestRatePercent: refinanceInterestRatePercent,
        refinanceLenderAndTitleFees: refinanceLenderAndTitleFees,
        refinanceMonthsTaxAndInsurance: refinanceMonthsTaxAndInsurance,
        refinanceMortgageInsuranceAnnual: refinanceMortgageInsuranceAnnual,
        hardShow: hardShow
      }
    };
    var url = `/properties/${propertyId}/evaluations/${evaluationId}/calculator`;
    return liberatorClient.put(url, {}, options);
  },

  updatePropertyEvaluationDealInputs(
    propertyId,
    evaluationId,
    estimatedMarketValue,
    estimatedAppraisedValue,
    purchasePrice,
    sellerContribution,
    survey,
    appraisal,
    inspection,
    repairsMakeReady,
    hoaAnnual,
    propertyTaxAnnual,
    propertyInsuranceAnnual,
    miscellaneousMonthly,
    rent
  ) {
    var headers = {
      headers: {
        estimatedMarketValue: estimatedMarketValue,
        estimatedAppraisedValue: estimatedAppraisedValue,
        purchasePrice: purchasePrice,
        sellerContribution: sellerContribution,
        survey: survey,
        appraisal: appraisal,
        inspection: inspection,
        repairsMakeReady: repairsMakeReady,
        hoaAnnual: hoaAnnual,
        propertyTaxAnnual: propertyTaxAnnual,
        propertyInsuranceAnnual: propertyInsuranceAnnual,
        miscellaneousMonthly: miscellaneousMonthly,
        rent: rent
      }
    };
    var url = `/properties/${propertyId}/evaluations/${evaluationId}/dealinputs`;
    return liberatorClient.put(url, {}, headers);
  },

  getUserConnections(userId, includeHidden) {
    var headers = {
      headers: {
        includeHidden: includeHidden
      }
    };
    var url = `/users/${userId}/connections`;
    return liberatorClient.get(url, headers);
  },

  addPropertyConnection(propertyId, connectionId) {
    var url = `/properties/${propertyId}/connections/${connectionId}`;
    return liberatorClient.post(url);
  },

  deletePropertyConnection(propertyId, connectionId) {
    var url = `/properties/${propertyId}/connections/${connectionId}`;
    return liberatorClient.delete(url);
  },

  newUserConnection(userId, type, name, phone, email) {
    var headers = {
      headers: {
        type: type,
        name: name,
        phone: phone,
        email: email
      }
    };
    var url = `/users/${userId}/connections`;
    return liberatorClient.post(url, {}, headers);
  },

  updateUserConnection(userId, connection) {
    var headers = {
      headers: {
        type: connection.type,
        name: connection.name,
        email: connection.email,
        phone: connection.phone,
        deleted: connection.deleted
      }
    };
    var url = `/users/${userId}/connections/${connection.id}`;
    return liberatorClient.put(url, {}, headers);
  },

  newUserConnectionAddToProperty(userId, propertyId, type, name, phone, email) {
    var headers = {
      headers: {
        type: type,
        name: name,
        phone: phone,
        email: email
      }
    };
    var url = `users/${userId}/properties/${propertyId}/connections`;
    return liberatorClient.post(url, {}, headers);
  },

  async addDocumentsToProperty(propertyId, files) {
    var url = `properties/${propertyId}/documents`;
    var result = await liberatorClient.post(url, files);
    return result;
  },

  deleteDocument(propertyId, documentId) {
    var url = `properties/${propertyId}/documents/${documentId}`;
    return liberatorClient.delete(url);
  },

  updateDocumentName(propertyId, documentId, documentName) {
    var headers = {
      headers: {
        name: documentName
      }
    };
    var url = `properties/${propertyId}/documents/${documentId}`;
    return liberatorClient.put(url, {}, headers);
  },

  async signin(email, password) {
    var headers = {
      headers: {
        email: email,
        password: password
      }
    };
    var url = `sessions`;
    return await liberatorClient.post(url, {}, headers);
  },

  async createSharedSession(guid, editKey) {
    var url = `sessions/sharing/${guid}/${editKey}`;
    return await liberatorClient.post(url);
  },

  copyEvaluation(propertyId, evaluationId) {
    var url = `properties/${propertyId}/evaluations/${evaluationId}/copy`;
    return liberatorClient.post(url);
  },

  updateEvaluationNotes(propertyId, evaluationId, notes) {
    var headers = {
      headers: {
        notes: notes
      }
    };
    var url = `properties/${propertyId}/evaluations/${evaluationId}/notes`;
    return liberatorClient.put(url, {}, headers);
  },

  getSession(sessionKey) {
    var url = `sessions/${sessionKey}`;
    return liberatorClient.get(url);
  },

  createEvaluationPdf(propertyId, evaluationId) {
    var url = `properties/${propertyId}/evaluations/${evaluationId}/pdf`;
    return liberatorClient.get(url);
  },

  // Return the URL that will create the PDF and return the binary PDF file.
  createEvaluationPdfUrl(propertyId, evaluationId, sessionKey) {
    var url =
      baseURL +
      `/properties/${propertyId}/evaluations/${evaluationId}/sessions/${sessionKey}`;
    return url;
  },

  // Generate a URL to the PDF and return just the URL.
  async getEvaluationPdfUrl(propertyId, evaluationId, sessionKey) {
    var url =
      baseURL +
      `/properties/${propertyId}/evaluations/${evaluationId}/sessions/${sessionKey}/url`;
    return await liberatorClient.get(url);
  },

  getSearchTypes(propertyId, evaluationId) {
    var url = `properties/${propertyId}/evaluations/${evaluationId}/searchTypes`;
    return liberatorClient.get(url);
  },

  updatePreferences(
    userId,
    mlsMarket,
    state,
    evaluationSalePlusMinusSqft,
    evaluationSalePlusMinusYearBuilt,
    evaluationSaleMonthsClosed,
    evaluationRentPlusMinusSqft,
    evaluationRentPlusMinusYearBuilt,
    evaluationRentMonthsClosed,
    evaluationRadius,
    dealSurvey,
    dealAppraisal,
    dealInspection,
    dealPropertyInsurancePercentListPrice,
    dealPropertyTaxPercentListPrice,
    dealRepairs,
    dealMaxRefiCashback,
    conventionalDownPayment,
    conventionalInterestRate,
    conventionalLenderFeesPercentOfListPrice,
    conventionalMonthsTaxEscrow,
    conventionalLoanTermInYears,
    hardLoanToValuePercent,
    hardLenderFeesPercentOfListPrice,
    hardInterestRate,
    hardMonthsUntilRefi,
    hardRollInLenderFees,
    hardWeeksUntilLeased,
    hardRefiLoanToValue,
    hardRefiLoanTermInYears,
    hardRefiInterestRate,
    hardRefiLenderFeesPercentListPrice,
    hardRefiMonthsTaxEscrow,
    operatingExpenses,
    capitalImprovements,
    closingCosts,
    startupCosts,
    prepaidsAndDeposits
  ) {
    var headers = {
      headers: {
        mlsMarket: mlsMarket,
        state: state,
        evaluationSalePlusMinusSqft: evaluationSalePlusMinusSqft,
        evaluationSalePlusMinusYearBuilt: evaluationSalePlusMinusYearBuilt,
        evaluationSaleMonthsClosed: evaluationSaleMonthsClosed,
        evaluationRentPlusMinusSqft: evaluationRentPlusMinusSqft,
        evaluationRentPlusMinusYearBuilt: evaluationRentPlusMinusYearBuilt,
        evaluationRentMonthsClosed: evaluationRentMonthsClosed,
        evaluationRadius: evaluationRadius,
        dealSurvey: dealSurvey,
        dealAppraisal: dealAppraisal,
        dealInspection: dealInspection,
        dealPropertyInsurancePercentListPrice: dealPropertyInsurancePercentListPrice,
        dealPropertyTaxPercentListPrice: dealPropertyTaxPercentListPrice,
        dealRepairs: dealRepairs,
        dealMaxRefiCashback: dealMaxRefiCashback,
        conventionalDownPayment: conventionalDownPayment,
        conventionalInterestRate: conventionalInterestRate,
        conventionalLenderFeesPercentOfListPrice: conventionalLenderFeesPercentOfListPrice,
        conventionalMonthsTaxEscrow: conventionalMonthsTaxEscrow,
        conventionalLoanTermInYears: conventionalLoanTermInYears,
        hardLoanToValuePercent: hardLoanToValuePercent,
        hardLenderFeesPercentOfListPrice: hardLenderFeesPercentOfListPrice,
        hardInterestRate: hardInterestRate,
        hardMonthsUntilRefi: hardMonthsUntilRefi,
        hardRollInLenderFees: hardRollInLenderFees,
        hardWeeksUntilLeased: hardWeeksUntilLeased,
        hardRefiLoanToValue: hardRefiLoanToValue,
        hardRefiLoanTermInYears: hardRefiLoanTermInYears,
        hardRefiInterestRate: hardRefiInterestRate,
        hardRefiLenderFeesPercentListPrice: hardRefiLenderFeesPercentListPrice,
        hardRefiMonthsTaxEscrow: hardRefiMonthsTaxEscrow,
        operatingExpenses: operatingExpenses,
        capitalImprovements: capitalImprovements,
        closingCosts: closingCosts,
        startupCosts: startupCosts,
        prepaidsAndDeposits: prepaidsAndDeposits
      }
    };
    var url = `users/${userId}/preferences`;
    return liberatorClient.put(url, {}, headers);
  },

  getMlsMarkets() {
    var url = `helpers/mlsMarkets`;
    return liberatorClient.get(url);
  },

  getStates() {
    var url = `helpers/states`;
    return liberatorClient.get(url);
  },

  updateUser(userId, email, password, firstName, lastName) {
    var headers = {
      headers: {
        email: email,
        password: password,
        firstName: firstName,
        lastName: lastName
      }
    };
    var url = `users/${userId}`;
    return liberatorClient.put(url, {}, headers);
  },

  getChargifyUrl(userId) {
    var url = `users/${userId}/chargifyUrl`;
    return liberatorClient.get(url);
  },

  getForSales(state, cities, zips, daysBack) {
    var headers = {
      headers: {
        state: state,
        cities: cities,
        zips: zips,
        daysBack: daysBack
      }
    };
    var url = `forsales`;
    return liberatorClient.get(url, headers);
  },

  getSearchHistory(maxCount) {
    var url = `forsales/history/${maxCount}`;
    return liberatorClient.get(url);
  },

  forgotPassword(email) {
    var headers = {
      headers: {
        email: email
      }
    };
    var url = `helpers/forgotpassword`;
    return liberatorClient.get(url, headers);
  },

  emailEvaluation(propertyId, evaluationId, to, subject, message) {
    var headers = {
      headers: {
        to: to,
        subject: subject,
        message: message
      }
    };
    var url = `properties/${propertyId}/evaluations/${evaluationId}/email`;
    return liberatorClient.get(url, headers);
  },

  getUserRights(userId) {
    var url = `useres/${userId}/rights`;
    return liberatorClient.get(url);
  },

  createSubscription(
    email,
    password,
    firstName,
    lastName,
    firstNameOnCard,
    lastNameOnCard,
    ccNumber,
    expirationMonth,
    expirationYear,
    cvv,
    trialPeriod
  ) {
    var headers = {
      headers: {
        apiKey: "f1aa4012-2a62-4f6c-b50d-b38857239d01",
        email: email,
        password: password,
        firstName: firstName,
        lastName: lastName,
        firstNameOnCard: firstNameOnCard,
        lastNameOnCard: lastNameOnCard,
        ccNumber: ccNumber,
        expirationMonth: expirationMonth,
        expirationYear: expirationYear,
        cvv: cvv,
        subscriptionType: "StandardMonthly",
        rights: "",
        trialPeriod
      }
    };
    var url = `subscriptions`;
    return liberatorClient.post(url, {}, headers);
  },

  reactivateSubscription(
    userId,
    firstNameOnCard,
    lastNameOnCard,
    ccNumber,
    expirationMonth,
    expirationYear,
    cvv
  ) {
    var headers = {
      headers: {
        userId: userId,
        firstNameOnCard: firstNameOnCard,
        lastNameOnCard: lastNameOnCard,
        ccNumber: ccNumber,
        expirationMonth: expirationMonth,
        expirationYear: expirationYear,
        cvv: cvv,
        subscriptionType: "StandardMonthly",
        rights: ""
      }
    };
    var url = `users/${userId}/reactivate`;
    return liberatorClient.put(url, {}, headers);
  },

  async getAllUsers() {
    var url = `users`;
    return await liberatorClient.get(url);
  },

  async updateUserRights(userId, rights) {
    var url = `users/${userId}/rights`;
    var headers = {
      headers: {
        rights: rights
      }
    };
    return await liberatorClient.put(url, {}, headers);
  },

  async getDefaultPreferences() {
    var url = `users/preferences/defaults`;
    return await liberatorClient.get(url);
  },
  
  async getEvaluationDashboardSettings() {
    var url = `users/evaluationdashboardsettings`;
    return await liberatorClient.get(url);
  },

  async saveEvaluationDashboardSettings(settings) {
    var url = `users/evaluationdashboardsettings`;
    return await liberatorClient.post(url, settings);
  },

  async resetPreferences(userId) {
    var url = `users/${userId}/preferences/defaults`;
    return await liberatorClient.put(url);
  },

  async getEvaluationUsage(startDate, endDate) {
    var url = `admin/evaluations/usage/${startDate.toISOString()}/${endDate.toISOString()}`;
    return await liberatorClient.get(url);
  },

  async getDownloadUrl(propertyId, documentId) {
    var url = `properties/${propertyId}/documents/${documentId}/url`;
    return await liberatorClient.get(url);
  },

  async getPresignedUrlForDocuments(propertyId, filename, filetype) {
    var url = `properties/${propertyId}/presignedurl`;
    var headers = {
      headers: {
        filename: filename,
        filetype: filetype
      }
    };
    return await liberatorClient.get(url, headers);
  },

  async getPresignedUrlForListings(propertyId, listingId, filename, filetype) {
    var url = `properties/${propertyId}/listings/${listingId}/presignedurl`;
    var headers = {
      headers: {
        filename: filename,
        filetype: filetype
      }
    };
    return await liberatorClient.get(url, headers);
  },

  async addDocument(propertyId, name, type, s3Key, size) {
    var url = `properties/${propertyId}/document`;
    var options = {
      headers: {
        name: name,
        type: type,
        s3Key: s3Key,
        size: size
      }
    };
    return await liberatorClient.post(url, {}, options);
  },

  async newSubscriptionEmployee(firstName, lastName, email, password, isAgent) {
    var url = `subscriptions/employee`;
    var options = {
      headers: {
        firstName: firstName,
        lastName: lastName,
        email: email,
        password: password,
        isAgent: isAgent
      }
    };
    return await liberatorClient.post(url, {}, options);
  },

  async getNotes(userId, includeInactive) {
    var url = `properties/notes`;
    var options = {
      headers: {
        includeInactive: includeInactive
      }
    };
    return await liberatorClient.get(url, {}, options);
  },

  async discoveryMigrate(
    username,
    password,
    ccNumber,
    firstNameOnCard,
    lastNameOnCard,
    expirationMonth,
    expirationYear,
    cvv
  ) {
    var url = `helpers/discoveryMigrate`;
    var options = {
      headers: {
        username: username,
        password: password,
        ccNumber: ccNumber,
        firstNameOnCard: firstNameOnCard,
        lastNameOnCard: lastNameOnCard,
        expirationMonth: expirationMonth,
        expirationYear: expirationYear,
        cvv: cvv
      }
    };
    return await liberatorClient.post(url, {}, options);
  },

  async getVersion() {
    var url = `helpers/version`;
    return await liberatorClient.get(url);
  },

  async updateEvaluationsPropertyAttributes(
    propertyId,
    evaluationId,
    baths,
    beds,
    county,
    garage,
    hoaAnnual,
    listDate,
    listPrice,
    mlsMarket,
    sqft,
    subdivision,
    taxesAnnual,
    yearBuilt
  ) {
    var url = `properties/${propertyId}/evaluations/${evaluationId}/attributes`;
    var options = {
      headers: {
        baths: baths,
        beds: beds,
        county: county,
        garage: garage,
        hoaAnnual: hoaAnnual,
        listDate: listDate,
        listPrice: listPrice,
        mlsMarket: mlsMarket,
        sqft: sqft,
        subdivision: subdivision,
        taxesAnnual: taxesAnnual,
        yearBuilt: yearBuilt
      }
    };
    return await liberatorClient.put(url, {}, options);
  },

  async newListing(
    propertyId,
    applicationPolicy,
    availableDate,
    baths,
    beds,
    city,
    depositPolicy,
    description,
    features,
    isActive,
    mapUrl,
    petPolicy,
    pictureUrls,
    rentPolicy,
    sqft,
    state,
    street,
    title,
    zip
  ) {
    var url = `properties/${propertyId}/listings`;
    var options = {
      headers: {
        applicationPolicy: applicationPolicy,
        availableDate: availableDate.toISOString(),
        baths: baths,
        beds: beds,
        city: city,
        depositPolicy: depositPolicy,
        description: description,
        features: features,
        isActive: isActive,
        mapUrl: mapUrl,
        petPolicy: petPolicy,
        pictureUrls: pictureUrls,
        rentPolicy: rentPolicy,
        sqft: sqft,
        state: state,
        street: street,
        title: title,
        zip: zip
      }
    };
    return await liberatorClient.post(url, {}, options);
  },

  async editListing(
    propertyId,
    listingId,
    applicationPolicy,
    availableDate,
    baths,
    beds,
    city,
    depositPolicy,
    description,
    features,
    isActive,
    mapUrl,
    petPolicy,
    pictureUrls,
    rentPolicy,
    sqft,
    state,
    street,
    title,
    zip
  ) {
    var url = `properties/${propertyId}/listings/${listingId}`;
    var options = {
      headers: {
        applicationPolicy: applicationPolicy,
        availableDate: availableDate.toISOString(),
        baths: baths,
        beds: beds,
        city: city,
        depositPolicy: depositPolicy,
        description: description,
        features: features,
        isActive: isActive,
        mapUrl: mapUrl,
        petPolicy: petPolicy,
        pictureUrls: pictureUrls,
        rentPolicy: rentPolicy,
        sqft: sqft,
        state: state,
        street: street,
        title: title,
        zip: zip
      }
    };
    return await liberatorClient.put(url, {}, options);
  },

  async addPicturesToListing(propertyId, listingId, s3Keys) {
    var url = `properties/${propertyId}/listings/${listingId}/pictures`;
    var options = {
      headers: {
        s3Keys: s3Keys
      }
    };
    return await liberatorClient.post(url, {}, options);
  },

  async deletePictureFromListing(propertyId, listingId, pictureUrl) {
    var url = `properties/${propertyId}/listings/${listingId}/pictureUrl`;
    var options = {
      headers: {
        pictureUrl: pictureUrl
      }
    };
    return await liberatorClient.delete(url, options);
  },

  async getListing(propertyId, listingId) {
    var url = `properties/${propertyId}/listings/${listingId}`;
    return await liberatorClient.get(url);
  },

  async getListingPublicLink(propertyId, listingId) {
    var url = `properties/${propertyId}/listings/${listingId}/publicLink`;
    return await liberatorClient.get(url);
  },

  async createBPO(propertyId) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpos`;
    return await liberatorClient.post(url);
  },

  async getBPO(propertyId, bpoId) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpos/${bpoId}`;
    return await liberatorClient.get(url);
  },

  async updateBpo(propertyId, bpoId, bpo) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpos/${bpoId}`;
    return await liberatorClient.put(url, bpo);
  },

  async getBpoByGuid(propertyId, bpoGuid) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpos/${bpoGuid}/guid`;
    return await liberatorClient.get(url);
  },

  async getBpo2ByGuid(propertyId, bpo2Guid) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpo2s/${bpo2Guid}/guid`;
    return await liberatorClient.get(url);
  },

  async copyBpo(propertyId, bpoId) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpos/${bpoId}/copy`;
    return await liberatorClient.post(url);
  },

  async createBpoPdf(propertyId, bpoGuid) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpos/${bpoGuid}/pdf`;
    return await liberatorClient.get(url);
  },

  async createBpo2Pdf(propertyId, bpo2Guid) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpo2s/${bpo2Guid}/pdf`;
    return await liberatorClient.get(url);
  },

  async emailBpo(propertyId, bpoId, to, subject, message) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpos/${bpoId}/email`;
    var options = {
      headers: {
        to: to,
        subject: subject,
        message: message
      }
    };
    return await liberatorClient.get(url, options);
  },

  async emailBpo2(propertyId, bpo2Id, to, subject, message) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpo2s/${bpo2Id}/email`;
    var options = {
      headers: {
        to: to,
        subject: subject,
        message: message
      }
    };
    return await liberatorClient.get(url, options);
  },

  async deleteBpo(propertyId, bpoId) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpos/${bpoId}`;
    return await liberatorClient.delete(url);
  },

  async getBpoPdf(propertyId, bpoGuid) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpos/${bpoGuid}/pdf`;
    return await liberatorClient.get(url);
  },

  async getBpo2Pdf(propertyId, bpo2Guid) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpo2s/${bpo2Guid}/pdf`;
    return await liberatorClient.get(url);
  },

  async createBpo2(propertyId, bpoId) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpo2s/${bpoId}`;
    return await liberatorClient.post(url);
  },

  async createBPO2FromScratch(propertyId) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpo2s`;
    return await liberatorClient.post(url);
  },

  async deleteBpo2(propertyId, bpo2Id) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpo2s/${bpo2Id}`;
    return await liberatorClient.delete(url);
  },

  async getBPO2(propertyId, bpo2Id) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpo2s/${bpo2Id}`;
    return await liberatorClient.get(url);
  },

  async updateBpo2(propertyId, bpo2Id, bpo2) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpo2s/${bpo2Id}`;
    return await liberatorClient.put(url, bpo2);
  },

  async getNaaSurveys() {
    var url = `helpers/naasurveys`;
    return await liberatorClient.get(url);
  },

  async copyBpo2(propertyId, bpo2Id) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpo2s/${bpo2Id}/copy`;
    return await liberatorClient.post(url);
  },

  async createLongFormFromScratch(propertyId) {
    var url = `properties/${propertyId}/evaluations/multifamily/longforms`;
    return await liberatorClient.post(url);
  },

  async createLongFormFromBpo2(propertyId, bpo2Id) {
    var url = `properties/${propertyId}/evaluations/multifamily/longforms/${bpo2Id}`;
    return await liberatorClient.post(url);
  },

  async getLongform(propertyId, longformId) {
    var url = `properties/${propertyId}/evaluations/multifamily/longforms/${longformId}`;
    return await liberatorClient.get(url);
  },

  async deleteLongform(propertyId, longformId) {
    var url = `properties/${propertyId}/evaluations/multifamily/longforms/${longformId}`;
    return await liberatorClient.delete(url);
  },

  async updateLongform(propertyId, longformId, longform) {
    var url = `properties/${propertyId}/evaluations/multifamily/longforms/${longformId}`;
    return await liberatorClient.put(url, longform);
  },

  async createRentComps(propertyId, rents) {
    var url = `properties/${propertyId}/evaluations/multifamily/rentcomps`;
    return await liberatorClient.put(url, rents);
  },

  async bpoPublishField(
    propertyId,
    bpoId,
    bpo,
    field,
    instanceGuid,
    timeStamp
  ) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpos/${bpoId}/publish/${field}/${instanceGuid}/${timeStamp}`;
    return await liberatorClient.put(url, bpo);
  },

  async bpo2PublishField(
    propertyId,
    bpo2Id,
    bpo2,
    field,
    instanceGuid,
    timeStamp
  ) {
    var url = `properties/${propertyId}/evaluations/multifamily/bpo2s/${bpo2Id}/publish/${field}/${instanceGuid}/${timeStamp}`;
    return await liberatorClient.put(url, bpo2);
  }
};
